export default __webpack_public_path__ + "static/media/equity.db05273d.jpg";